<mat-expansion-panel
  *ngIf="selectedSite"
  #expansionPanel
  class="context-selection-panel white"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span class="container mat-drawer-container">
        <mat-chip class="mint-chip" *ngIf="selectedMerchantType">
          {{ "MERCHANT.TYPE_CATEGORIZED." + selectedMerchantType | translate }}
        </mat-chip>
        <div class="telep-data">
          <span class="name">{{ selectedSite.name }}</span>
          <span class="address"
            >{{ selectedSite.address.city }}
            {{ selectedSite.address.streetName }}
            {{ selectedSite.address.streetType }}
            {{ selectedSite.address.number }}
          </span>
        </div>
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ul *ngIf="choosableContexts">
    <li
      *ngFor="let context of choosableContexts"
      (click)="switchContext(context)"
    >
      <span class="container mat-drawer-container">
        <mat-chip class="mint-chip" *ngIf="context.merchantType">
          {{ "MERCHANT.TYPE_CATEGORIZED." + context.merchantType | translate }}
        </mat-chip>
        <div class="telep-data">
          <span class="name">{{ context.siteName }}</span>
          <span class="address"
            >{{ context.address.city }}
            {{ context.address.streetName }}
            {{ context.address.streetType }}
            {{ context.address.number }}
          </span>
        </div>
      </span>
    </li>
    <li>
      <a
        class="add-new-site-btn d-flex gap-3 align-items-center justify-content-center"
        [routerLink]="'/account/merchant/sites/create'"
        (click)="panel?.close()"
        ><mat-icon>add</mat-icon>Új telephely hozzáadása</a
      >
    </li>
  </ul>
</mat-expansion-panel>
